
class MarQuee{


	constructor(dom){
		this.dom=dom;
		this.x=0;
		this.speed=1;
		
		window.addEventListener("resize",function(){
			
			this.resize();

		}.bind(this))
		this.resize();
		this.interval=setInterval(function(){

			this.animate();
		}.bind(this),30)
				
				/*var clone = text.cloneNode(true);
				marquee.appendChild(clone);
				var w=clone.getBoundingClientRect().width;
				var c=0;
				while(c*w<window.innerWidth*2){
					marquee.appendChild(clone);
					
					clone = text.cloneNode(true);
					

					
					c++;
					if(c>20){
						break;

					}
				}

				let start = null;
				const speed = 1; // px per second
				let POS=0;
				function animate() {
					
					POS-=speed;

					var m=(marquee.children[1]);
					var left=(m.getBoundingClientRect().left);
					if(left<0){
						console.log("YLI");
						POS=left;
					}

					marquee.style.transform = `translateX(${POS}px)`;
					


				}
				setInterval(function(){

					animate();
				},30)
*/


	}
	animate(){

		this.x-=this.speed;
		var m=(this.dom.children[1]);
		var left=(m.getBoundingClientRect().left);
		if(left<0){
			
			this.x=left;
		}
		this.dom.style.transform = `translateX(${this.x}px)`;
	}
	resize(){
		var text = this.dom.querySelector(".text");
		var w=text.getBoundingClientRect().width;
		

		var c= this.dom.querySelectorAll(".text").length;
		while(c*w<window.innerWidth*2){
			var clone = text.cloneNode(true);
			this.dom.appendChild(clone);
		
			
			

			
			c++;
			if(c>50){
				console.log("LIMIT");
				break;

			}
		}



		
	}
}




class Strip{


	constructor(dom){
		this.dom=dom;
		this.resize();
		window.addEventListener("resize",function(){
			this.resize();
			
		}.bind(this));
	}
	resize(){

		var w=this.dom.parentNode.getBoundingClientRect().width;
		var items=this.dom.querySelectorAll(".strip-item");
		for(var i=0;i<items.length;i++){
			items[i].style.width=w+"px";
		}
	}
}

class App {

	constructor() {
		document.addEventListener('DOMContentLoaded', () => {
			this.start();
		});
	}

	/**
	 * App entry point
	 */
	start() {
		/*var strips=document.querySelectorAll(".strip");

		for(var i=0;i<strips.length;i++){
			new Strip(strips[i]);
		}*/

		var btn=document.getElementById("nav-button");
		if(btn){
			btn.addEventListener("click",function(){
				var body=document.querySelector("body");
				if(body.classList.contains("navi-open")){
					body.classList.remove("navi-open");
				}else{
					body.classList.add("navi-open");
				}

			});
		}


		var all=document.querySelectorAll(".navs .n");
		
		function activateDjs(index,all,stripts){
			for(var i=0;i<all.length;i++){

				if(all[i].getAttribute("data-index")==index){
					all[i].classList.add("active");
				}else{
					all[i].classList.remove("active");
				}
			}
			var strips=document.querySelectorAll(".strip");
			for(var i=0;i<strips.length;i++){

				var items=strips[i].querySelectorAll(".strip-item");

				for(var x=0;x<items.length;x++){
				if(index==x){
					items[x].style.display="";
				}else{
					items[x].style.display="none";
				}
			}
			}




		}
		for(var i=0;i<all.length;i++){
			all[i].addEventListener("click",function(e){
				activateDjs(e.currentTarget.getAttribute("data-index"),all);

			});
		}

		const marquees = document.querySelectorAll(".wp-block-airi-marquee .track");
		
		for(var i=0;i<marquees.length;i++){
			new MarQuee(marquees[i]);
			
		}

		var SCROLL_TARGET=0;
		var SCROLL_NOW=0;
		var m=document.querySelector("header.wp-block-airi-header");
		if(m){
			window.addEventListener("scroll",function(e){

				SCROLL_TARGET=-(window.scrollY*.2);
			});
			var INTERVAL=setInterval(function(){
			
				var diff=SCROLL_TARGET-SCROLL_NOW;
				var amount=diff*.05;
				
				SCROLL_NOW+=amount;
			//	console.log(m);
				m.style.backgroundPosition = SCROLL_NOW+"px bottom";
	
				
	
			},20);
		}
		

	}
}

const app = new App();
